import { ConnectedRouter } from 'connected-react-router';
import { Redirect, Switch } from 'react-router-dom';
import { browserHistory } from '../../libs/IdeLink.Web.Common/src/redux/BrowserHistory';
import { RouteItem } from '../../libs/IdeLink.Web.Common/src/types/RouteItem';
import React from 'react';
import { PrivateRoute } from './PrivateRoute';

export type RouterProps = { routerHistory?: any; routes: Array<RouteItem>; defaultRoute: string };

export const AppRouter = ({ routerHistory = browserHistory, routes = [], defaultRoute }: RouterProps) => {
	return (
		<ConnectedRouter history={routerHistory}>
			<Switch>
				{routes.map(({ render: Render, props }: RouteItem) => {
					const { exact = true } = props;
					return (
						<Render
							key={`${props.path}_${exact ? 'exact' : ''}`}
							{...props}
							exact={exact}
						/>
					);
				})}
				{/* Go to defaultRoute or /login is not logged in */}
				<PrivateRoute
					path="**/*"
					component={() => <Redirect to={defaultRoute} />}
				></PrivateRoute>
			</Switch>
		</ConnectedRouter>
	);
};
